import React from 'react';
import { useState } from "react";
import Navbar from '../components/Internal-nav';  
import './gallery.scss';
import { Gallery } from "react-grid-gallery";
import { images} from "../data/photos.js";
import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css';
  
function GalleryPage() {


    const [index, setIndex] = useState(-1);

    const currentImage = images[index];
    const nextIndex = (index + 1) % images.length;
    const nextImage = images[nextIndex] || currentImage;
    const prevIndex = (index + images.length - 1) % images.length;
    const prevImage = images[prevIndex] || currentImage;

    const handleClick = (index, item) => setIndex(index);
    const handleClose = () => setIndex(-1);
    const handleMovePrev = () => setIndex(prevIndex);
    const handleMoveNext = () => setIndex(nextIndex);

    return (
      <div className='App'>
      <header>
        <Navbar />
      </header>
      <div>
        <div className='inner-banner' style={{ backgroundImage: "url(../assets/shop-photo-banner.jpg)"}}>
          <div className='banner-content'>
          <h1>Our Work</h1>
          </div>
        </div>
            
            <div className='container'>
                <div className='gallery'>
                    <Gallery
                    images={images}
                    onClick={handleClick}
                    enableImageSelection={false}
                    
                    />
                    {!!currentImage && (
                      <Lightbox
                        mainSrc={currentImage.original}
                        mainSrcThumbnail={currentImage.src}
                        nextSrc={nextImage.original}
                        nextSrcThumbnail={nextImage.src}
                        prevSrc={prevImage.original}
                        prevSrcThumbnail={prevImage.src}
                        onCloseRequest={handleClose}
                        onMovePrevRequest={handleMovePrev}
                        onMoveNextRequest={handleMoveNext}
                      />
                    )}


                 </div>
            </div>
         </div>
      </div>
    );
  };
  
export default GalleryPage;